import React, { SVGProps } from "react";
export const FoodIcon2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 128 128"
    {...props}
  >
    <path
      fill="#d4d4d3"
      d="M68.01 37.37 13.25 48.59s-8.4 7.57-8.88 20.15c-.23 6.11.79 18.26 11.89 28.63 8.63 8.06 23.07 14.56 47.12 15.08 22.32.48 37.19-6.66 46.14-14.23 11.95-10.1 13.82-22.23 13.57-30.25-.4-12.68-10.45-19.8-11.34-20.91s-43.74-9.69-43.74-9.69z"
    />
    <path
      fill="#f7f6f5"
      d="M63.09 107.24c39.84 0 58.41-21.87 57.97-42.09-.45-20.52-28.72-35.12-57.22-34.6-49.73.9-56.62 24.12-56.92 36.7-.35 14.83 13.18 39.99 56.17 39.99z"
    />
    <path
      fill="#df7f14"
      d="M12.01 63.05C9.17 74.89 18 101.7 63.69 101.7c42.39 0 53.32-24.41 53.32-36.25 0-12.13-11.38-33.4-54.97-31.01-41.65 2.29-48.5 22.24-50.03 28.61z"
    />
    <path
      fill="#ff5119"
      d="M92.75 47.43c.45.89 3.71 1.74 6.17 2.34s5.81 1.26 6.53-.12c.72-1.38-1.62-4.91-4.43-6.41-2.82-1.5-5.48.09-6.11.6-.96.78-2.82 2.28-2.16 3.59z"
    />
    <path
      fill="#f5b03e"
      d="M16.05 63.26c-1.52 0-3.28 3.6-1.77 7.13s3.53 4.79 4.23 6.62c.69 1.83 1.45 6.24 4.6 9.34 3.15 3.09 7.7 3.53 9.59 4.16 1.89.63 6.94 4.74 15.08 5.99 9.02 1.39 21.51-1.01 21.32-2.9-.19-1.88-13.44-3.6-15.9-4.16s-11.42-2.02-17.91-5.42c-5.37-2.82-9.71-5.93-14.32-12.81-3.3-4.93-4.04-7.95-4.92-7.95z"
    />
    <path
      fill="#fefefe"
      d="m44.28 22.47-5.5 4.7-8.37 3.17-2.43 7.19s-4 2.77-4.17 3.82c-.16 1.05-2.54 9.77-2.54 9.77s-.62 3.39-.57 4.92c.05 1.53 5.67 13.07 24.35 16.35 18.68 3.28 30.66-.77 38.83-5.37 7.75-4.37 9.16-9.05 9.16-9.05l-.4-8.22s-2.52-9.64-3.49-11.8-8.27-10.13-8.73-10.26-9.86-5.96-9.86-5.96L56.8 18.9l-12.52 3.57zM15.85 67.62c-.96.46-.38 2.51.88 4.34s2.34 2.63 3.26 5.43c.92 2.8 2.84 7.64 6.35 9.65s5.6.33 5.68-.75c.12-1.62-1.92-1.75-5.56-5.39-3.66-3.66-6.31-8.19-7.69-10.36-.83-1.32-1.96-3.38-2.92-2.92zM39.07 87.33c-1.25-.75-3.13 1.25-1.55 4.13 1.59 2.88 4.3 2.21 4.47 1.21.27-1.63-1.29-1.96-1.8-2.97-.49-.99.23-1.56-1.12-2.37z"
    />
    <path
      fill="#b0b0b0"
      d="M29.45 38.57s-3.03 1.02-4.1 4.06c-1.08 3.04-1.09 7.07-1.09 7.07s-1.86 1.37-2.65 3.44c-.83 2.18-.52 3.86-.86 3.79-.76-.16-1.29-3.51-1.03-5.18.34-2.14 1.26-2.98 1.26-2.98s-.64-4.69 1.09-8.12c1.72-3.43 4.59-5.15 4.59-5.15s1.09-4.67 3.92-7 6.04-2.72 6.04-2.72 1.15-3.46 4.74-5.45c3.6-1.99 7.53-1.03 7.53-1.03s3.58-2.93 8.51-2.93c4.92 0 7.27 2.57 7.27 2.57s4.22-.65 7.34.95 4.89 4.35 4.89 4.35 3.35.6 5.84 3.03c2.62 2.55 3.63 5.71 3.63 5.71s4.5 2.48 6.02 6.2c1.85 4.54.65 9.02.65 9.02s1.89 2.33 1.58 5.72c-.3 3.39-1.98 6.45-2.68 6.22-.15-.05.61-4.58-.02-6.86-.51-1.85-2.47-4.66-2.47-4.66s.28-5.22-1.37-8.18c-1.65-2.95-4.7-3.92-4.7-3.92s-1.19-3.88-3.46-5.91c-2.27-2.04-4.88-2.2-4.88-2.2s-2.31-3.5-4.99-4.51c-2.68-1.01-5.47-.55-5.47-.55s-3.66-2.33-7.28-2.31c-3.99.02-6.92 2.63-6.92 2.63s-3.41-1.14-6.65 1.07c-3.24 2.22-4.14 4.8-4.14 4.8s-3.78.31-6.23 2.45-3.91 6.58-3.91 6.58z"
    />
    <path
      fill="#d4d4d3"
      d="M73.18 34.2c-1.76.03-1.87 2.46-2.71 3.93-.75 1.31-3.57 1.96-2.45 3.83 1 1.67 4.7.78 6.11-2.17.99-2.06 1.29-5.62-.95-5.59zM80.48 43.04c-1.7.18-1.03 2.44-1.61 4.18s-2.75 3.33-1.54 4.52c1.21 1.19 4.03-.75 4.88-3.91s-.34-4.94-1.73-4.79zM71.25 49.37c-1.93-.04-1.56 1.99-2.73 3.71-1.17 1.71-2.75 2.32-2 3.53s3.55 1.42 5.25-1.75c1.62-3.04.95-5.46-.52-5.49zM72.92 61.17c-1.34 2.17-3.62 1.94-2.9 3.78.74 1.89 4.11 1.1 5.74-1.39 1.37-2.11 2.44-5.65.08-5.76-1.97-.08-1.83 1.61-2.92 3.37zM60.12 59.85c-1.4.14-1.41 1.88-2.41 3.17-1.16 1.51-3.36 1.79-2.59 3.59s4.18 1.57 6.01-1c1.54-2.15 1.65-6.02-1.01-5.76z"
    />
    <path
      fill="#ff8e00"
      d="M21.95 62.83c-.93.28-2.03 3.11-1.8 4.13.3 1.32 3.23 4.01 4.91 3.95s5.21-2.28 5.57-3.17c.36-.9.06-2.82-.36-3.35-.42-.54-1.86-2.04-2.7-2.04s-4.42.12-5.62.48z"
    />
    <path
      fill="#fcc219"
      d="M25.9 71.39c-.94 1.41.24 3.23 1.2 4.37.96 1.14 3.23 4.11 7.61 3.65 5.21-.54 7.01-5.87 7.01-8.15s-.72-3.71-2.46-3.35c-2.27.47-2.28 2.04-4.79 2.64-2.52.6-7.25-1.13-8.57.84z"
    />
    <path
      fill="#ff8e00"
      d="M41.06 77.56c-.16 1.43-.18 4.55 1.14 5.03 1.32.48 6.83.06 7.79-.24s1.32-2.4.72-3.23c-.6-.84-4.73-4.13-6.41-4.07s-3.18 1.97-3.24 2.51z"
    />
    <path
      fill="#ff5319"
      d="M52.74 84.27c1.08.54 2.04 4.61 1.74 5.57-.3.96-1.38 2.82-1.92 2.99-.54.18-5.33.24-7.31-.06-1.72-.26-3.65-2.28-3.47-4.91.18-2.64 2.1-3.59 4.91-3.83 2.81-.24 6.05.24 6.05.24zM59.21 74.63c-1.72.27-5.21 3.05-5.33 5.39s1.68 4.07 3.11 4.07c1.44 0 7.07-5.81 6.71-6.89-.36-1.08-2.22-2.93-4.49-2.57z"
    />
    <path
      fill="#f8c977"
      d="M63.34 80.32c.89 1.09 4.55 3.29 6.59 2.94s7.01-2.4 6.53-5.33c-.48-2.94-4.73-6.53-6.41-7.13-1.68-.6-4.43-.18-5.63.9-1.2 1.07-2.16 7.3-1.08 8.62z"
    />
    <path
      fill="#fcc219"
      d="M82.03 73.55c-1.45.04-2.28 1.8-2.52 2.4-.24.6-.78 2.64-1.44 3.95-.66 1.32-3.71 4.67-2.58 6.47 1.14 1.8 3.53 1.44 6.59.96 3.05-.48 5.39-1.8 5.75-4.55.36-2.76.6-4.97-.12-5.81-.71-.85-3.41-3.48-5.68-3.42z"
    />
    <path
      fill="#ff8e00"
      d="M75.14 91.52c1.26-.72 6.11-4.49 7.91-4.43s3.47 1.38 3.95 2.46.66 4.13-.36 4.97c-1.02.84-4.37 1.32-5.81 1.44s-6.54.71-6.89-1.68c-.3-2.04 1.2-2.76 1.2-2.76z"
    />
    <path
      fill="#ff5119"
      d="M92.57 82.89c-.06 2.82 4.67 4.67 6.11 4.73s4.61-.72 6.29-2.94c1.1-1.46 2.1-3.77 1.5-5.21s-1.38-2.7-3.47-2.88c-2.1-.18-6.65-.36-7.85.48-1.2.85-2.56 4.81-2.58 5.82z"
    />
    <path
      fill="#f8c977"
      d="M91.19 68.04c-.55.95.44 4.09 1.74 5.45 1.08 1.14 2.7 2.4 6.05 2.04s6.53-2.58 7.25-3.65c.72-1.08 1.74-3.29 1.14-4.37-.6-1.08-5.99-.42-8.45-.42s-7.07-.19-7.73.95z"
    />
    <path
      fill="#f9ca76"
      d="M103.47 52.88c-.11 1.08 1.92 2.88 2.76 3.47.84.6 3.29 1.26 4.13.72.84-.54.97-3.87.6-4.79-.48-1.2-2.64-2.46-4.01-2.16-1.38.31-3.36 1.63-3.48 2.76z"
    />
    <path
      fill="#ff8e00"
      d="M101.85 53.66c-1.62 1.02-3.95 4.55-4.55 5.63-.6 1.08-1.86 3.59.3 4.43 2.16.84 6.29.12 7.79-.6s4.37-2.22 4.43-4.13-1.32-3.29-2.99-4.37-3.27-2.03-4.98-.96z"
    />
    <path
      fill="#fcc219"
      d="M107.9 65.94c.94 1.09 2.22.96 4.13.6 1.92-.36 4.43-1.2 4.19-2.94s-2.22-2.99-3.17-3.41c-.96-.42-4.25-.24-5.21.96-.95 1.2-.71 3.89.06 4.79z"
    />
  </svg>
);
